'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

function by(bToA, eqA, b1, b2) {
  return Curry._2(eqA, Curry._1(bToA, b1), Curry._1(bToA, b2));
}

var Contravariant = {
  cmap: by
};

function invert(eqA, a1, a2) {
  return !Curry._2(eqA, a1, a2);
}

var cmap = by;

exports.by = by;
exports.cmap = cmap;
exports.Contravariant = Contravariant;
exports.invert = invert;
/* No side effect */
